enum DeviceType {
  SPINE = 'spine',
  SPINE_MULTI_MEASUREMENT = 'spine_multi_measurement',
  VALVE = 'valve'
}

export default DeviceType
